import {
  IconAtom,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLocation,
  IconMeter,
  IconPcLine,
  IconPlug,
  IconRoad,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTools,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';

import integrationVideo from '@src/assets/images/main/video/integration.mp4';

import image2 from '@src/assets/images/solution/medicalWaste/img/2.avif';
import image3 from '@src/assets/images/solution/medicalWaste/img/3.avif';
import image4 from '@src/assets/images/solution/medicalWaste/img/4.avif';
import image5 from '@src/assets/images/solution/medicalWaste/img/5.avif';
import image6 from '@src/assets/images/solution/medicalWaste/img/6.avif';
import image7 from '@src/assets/images/solution/medicalWaste/img/7.avif';
import image8 from '@src/assets/images/solution/medicalWaste/img/8.avif';
import image9 from '@src/assets/images/solution/medicalWaste/img/9.avif';

export default {
  type: '医療ソリューション',

  banner: {
    title: 'ロボットベースの自動化システムで医療廃棄物管理を効率化',
    desc: 'ロボットとORBRO位置追跡システムを組み合わせ、医療廃棄物の位置をリアルタイムで把握し、自動化された運用管理を実現します。',
  },

  video: {
    title: 'ロボットと位置追跡システムを融合したスマート医療廃棄物管理',
    desc: 'ロボットによる医療廃棄物管理とORBRO位置追跡システムの統合により、正確な位置監視と自動管理が可能になり、運用効率を大幅に向上させます。',
    play: integrationVideo,
  },

  func: [
    {
      theme: 'ロボットの位置をリアルタイムで把握し、医療廃棄物を効率管理',
      title: 'リアルタイムロボット位置追跡と運用モニタリング',
      desc: 'ロボットの位置と運用状態を正確に把握し、即時対応で管理精度を高め、運用効率を最大化します。',
      sub1: '高精度提供',
      icon1: IconRulerGray,
      sub2: '迅速データ連携',
      icon2: IconShareGray,
      image: image2,
    },
    {
      title: '自律走行で積み下ろし場へ移動',
      desc: 'ロボットが自律走行で積み下ろし場へ安全に移動し、人の介入なしで作業を実行、効率性と作業者の安全を確保します。',
      sub1: 'リスク資産指定',
      icon1: IconWarningGray,
      sub2: '対応方法設定',
      icon2: IconBellGray,
      image: image3,
    },
    {
      title: '積載装置との自動連携運用',
      desc: '積載装置とロボットの自動連携を構築し、ロボット呼び出しや積載準備をスムーズに管理し、作業効率と処理速度を大幅に向上させます。',
      sub1: '高精度提供',
      icon1: IconRulerGray,
      sub2: '迅速データ連携',
      icon2: IconChainLinkGray,
      image: image4,
    },
    {
      title: 'スマートロッカー連携',
      desc: 'スマートロッカーとシステムを連携し、データアクセスと資産管理を簡単かつ便利に行い、運用の利便性と正確性を高めます。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      theme: '機器状態をリアルタイムで把握し、消毒管理を自動化',
      title: '作業状態リアルタイムモニタリング',
      desc: '各ロボットの作業状態をリアルタイムで監視し、問題発生時には即時対応、運用中のエラーを最小化し、安全な管理環境を提供します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '複数ロボットの同時管理',
      desc: '複数のロボットを一つのシステムで同時に管理し、管理効率を高め、作業の重複や衝突を防ぎ、スムーズな作業をサポートします。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '消毒システムとの連携と管理',
      desc: 'プラズマ、UVC、HPV消毒装置と簡単に連携し、医療廃棄物や医療器具の滅菌作業を迅速かつ正確に行い、衛生環境を維持します。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image8,
    },
    {
      title: '機器別作業状態リアルタイム確認',
      desc: '各消毒装置の接続状態と作業進捗をリアルタイムで正確に監視し、運用中の問題を事前に把握し、即座に対応可能です。',
      sub1: '統計データ提供',
      icon1: IconChartBarGray,
      sub2: 'クラウド保存',
      icon2: IconCloudCheckGray,
      image: image9,
    },
  ],

  subfunc: {
    title: '主な機能概要',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: 'ロボット位置リアルタイム追跡',
        desc: 'ロボットの現在位置を正確に把握し、運用状況をリアルタイムでモニタリングします。',
      },
      {
        icon: IconMeter,
        title: '作業状態リアルタイムモニタリング',
        desc: 'ロボットの作業進行状況をリアルタイムで検知し、迅速に対応可能です。',
      },
      {
        icon: IconUserCheck,
        title: '複数ロボット同時管理',
        desc: '複数ロボットを効率的に同時管理し、運用の正確性を向上させます。',
      },
      {
        icon: IconRoad,
        title: '自律走行ロボットの積み下ろし場移動',
        desc: 'ロボットが積み下ろし場まで自律走行で移動し、作業効率と安全性を高めます。',
      },
      {
        icon: IconPlug,
        title: '積載装置との自動連携',
        desc: 'ロボット呼び出しと積載準備を自動で管理し、運用効率を高めます。',
      },
      {
        icon: IconPcLine,
        title: 'ロボット専用管理ダッシュボード',
        desc: 'ロボットの運用状況とデータを直感的に管理できる専用ダッシュボードを提供します。',
      },
      {
        icon: IconRoom,
        title: 'スマートロッカーシステム連携',
        desc: 'ロッカーと連携し、医療廃棄物の保管状況を効率的に管理します。',
      },
      {
        icon: IconTools,
        title: '消毒装置リアルタイムモニタリング',
        desc: '各消毒装置の接続と作業状態をリアルタイムで監視し、安定運用を支援します。',
      },
      {
        icon: IconAtom,
        title: '多様な消毒システム連携',
        desc: 'プラズマ、UVC、HPV消毒装置と連携し、迅速かつ完全な滅菌を支援します。',
      },
      {
        icon: IconChartBar,
        title: 'リアルタイム現況統合管理',
        desc: 'すべての機器の運用状態と在庫状況を一画面で統合管理し、迅速な意思決定をサポートします。',
      },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'medicalPatient',
    },
    {
      data: 'officeAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
